import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IP } from "../../../../config/IP";
import util from "../../../services/util";
import Thumb from "../../Thumb";

const Product = (props) => {
	const product = props.product;
	const state = useSelector((state) => state);
	const [site, setSite] = useState("");
	const [company, setCompany] = useState("");

	product.quantity = 1;

	let formattedPrice = util.formatPrice(product.price, product.currencyId);

	let productInstallment;

	if (!!product.installments) {
		const installmentPrice = product.price / product.installments;

		productInstallment = (
			<div className="installment">
				<span>or {product.installments} x</span>
				<b>
					{" "}
					{product.currencyFormat}{" "}
					{util.formatPrice(installmentPrice, product.currencyId)}
				</b>
			</div>
		);
	}

	useEffect(() => {
		if (state.companyData.isSaved && product.companyId) {
			console.log(
				"state.companyData.allCompany=",
				state.companyData.allCompany
			);
			console.log("product=", product);
			try {
				setCompany(
					state.companyData.allCompany.find((x) => x._id === product.companyId)
						.companyName
				);

				setSite(
					state.companyData.allCompany
						.find((x) => x._id === product.companyId)
						.site.find((x) => x._id === product.siteId).name
				);
			} catch (e) {}
		}
	}, [state.companyData.isSaved]);

	return (
		<div
			className="shelf-item"
			onClick={() => props.addProduct(product)}
			data-sku={product.sku}
		>
			{product.isFreeShipping && (
				<div className="shelf-stopper">Free shipping</div>
			)}
			<Thumb
				classes="shelf-item__thumb"
				//src={require(`../../../static/products/${product.sku}_1.jpg`)}
				//src={require(`../../../static/products/12064273040195392_1.jpg`)}
				src={`${IP.nodeServer}api/getProductPhoto?album=${encodeURIComponent(
					product.sku
				)}`}
				alt={product.title}
			/>
			<p className="shelf-item__title">{product.title}</p>
			<div className="shelf-item__price">
				<div className="val">
					<small>{product.currencyFormat}</small>
					<b>
						{
							new Intl.NumberFormat("en-IN", {
								maximumSignificantDigits: 3,
							}).format(parseFloat(formattedPrice))
							/*formattedPrice.substr(0, formattedPrice.length - 3)*/
						}
					</b>
					<span>{formattedPrice.substr(formattedPrice.length - 3, 3)}</span>
				</div>
				{productInstallment}
			</div>

			<div className="shelf-item__buy-btn">Add to cart</div>
			<div className="val">
				<font size="1">By {company + "/" + site}</font>
			</div>
		</div>
	);
};

Product.propTypes = {
	product: PropTypes.object.isRequired,
	addProduct: PropTypes.func.isRequired,
};

export default Product;
